export const API_URL = window.API_ROOT + '/api'
